import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseCard from './BaseCard';
import BaseDetailModal from './BaseDetailModal';
import { BASE_KEYS } from '../constants';

export default function BaseList({
  baseList,
  config,
  loading,
  error,
  actionLoadingCityId,
  piUser,
  onCapture,
  onReserve,
  onCancelReservation,
  ownsGenesis,
  myReservation,
  myReservations,
  showConfirm,
  onCityClick,
  myPos,
  ticketCount
}) {
  const { t } = useTranslation();
  const [selectedBase, setSelectedBase] = useState(null);

  useEffect(() => {
    if (!selectedBase?.cityId) return;
    const nextBase = baseList.find((item) => item.cityId === selectedBase.cityId);
    setSelectedBase(nextBase || null);
  }, [baseList, selectedBase?.cityId]);

  // 유저가 현재 보유 중인 BASE 수 (다중 점유 제한 판단용)
  const reservationCount = Array.isArray(myReservations)
    ? myReservations.length
    : (myReservation ? 1 : 0);
  const myActiveBasesCount = (baseList || []).filter((b) => b.isMyBase).length + reservationCount;

  const handleCapture = async (cityId) => {
    await onCapture(cityId);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {loading && baseList.length === 0 ? (
        <div style={{ padding: 24, textAlign: 'center', color: '#6B7280', fontWeight: 700 }}>
          {t('spot_loading')}
        </div>
      ) : (
        baseList.map((base, index) => (
          <BaseCard
            key={base.cityId}
            base={base}
            imageLoading={index < 3 ? 'eager' : 'lazy'}
            myPos={myPos}
            onClick={() => {
              setSelectedBase(base);
              if (onCityClick) onCityClick(base.cityId);
            }}
            onMapClick={onCityClick}
          />
        ))
      )}

      {error && !selectedBase && (
        <div style={{ padding: 12, color: '#EF4444', fontSize: '0.8rem', fontWeight: 700 }}>
          {t(BASE_KEYS.ERROR)}
        </div>
      )}

      <BaseDetailModal
        base={selectedBase}
        myActiveBasesCount={myActiveBasesCount}
        config={config}
        piUser={piUser}
        loading={!!selectedBase && actionLoadingCityId === selectedBase.cityId}
        error={error}
        onClose={() => setSelectedBase(null)}
        onCapture={handleCapture}
        onReserve={onReserve}
        onCancelReservation={onCancelReservation}
        ownsGenesis={ownsGenesis}
        myReservation={myReservation}
        myReservations={myReservations}
        showConfirm={showConfirm}
        ticketCount={ticketCount}
      />
    </div>
  );
}
